import React from "react";
import { HashRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import Home from "./Home/Home";
import TermsAndConditions from "./TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy";
import Support from "./Support/Support";
import DeleteAccount from "./DeleteAccount/DeleteAccount";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="app">
        <nav className="navbar">
          <NavLink
            to="/"
            className="nav-link"
            activeClassName="active-link"
            exact
          >
            Start
          </NavLink>
          <NavLink
            to="/privacy-policy"
            className="nav-link"
            activeClassName="active-link"
          >
            Privacy Policy
          </NavLink>
          <NavLink
            to="/terms-and-conditions"
            className="nav-link"
            activeClassName="active-link"
          >
            Terms & Conditions
          </NavLink>
          <NavLink
            to="/support"
            className="nav-link"
            activeClassName="active-link"
          >
            Support
          </NavLink>
          <NavLink
            to="/delete-account"
            className="nav-link"
            activeClassName="active-link"
          >
            Delete Account
          </NavLink>
        </nav>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/support" element={<Support />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
